// extracted by mini-css-extract-plugin
export default {"cancelButtonCustom":"ScaleAdmin_cancelButtonCustom__JDhpU","nextButtonCustom":"ScaleAdmin_nextButtonCustom__qu5bN"};